module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"meatup2019","short_name":"meatup2019","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/oniku.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a958d28f397774e4efedd07cccacb042"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
